import React from 'react';
import T from './modules/translation';

class TrialMove extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      checked: false
    }
  }

  onChange(event) {
    this.setState({
      checked: event.target.checked
    });
    this.props.onChange(event);
  }

  render() {
    return (
      <div className={this.state.checked 
          ? "trialMoveCheckBox form-check form-check-inline bg-primary text-white pt-1 pb-1 pe-1 ms-3"
          : "trialMoveCheckBox form-check form-check-inline ms-3"}>
          <input className="form-check-input" type="checkbox" 
            id="trialMove" name="trialMove"
            data-toggle="tooltip"
            data-placement="bottom"
            data-trigger="hover"
            title={T.get("trialMoveToolTip")}
            onChange={this.onChange}
            checked={this.state.checked} />
          <label className="checkbox-inline" htmlFor="trialMove">
            {T.get("trialMove")}
          </label>
        </div>
    );
  }
}
export default TrialMove;